import React, { Fragment, useState, useEffect, useContext } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import {
  customerFilterColumns,
  searchColumns,
} from "../../Data/Customers/CustomerData";
import { Breadcrumbs } from "../../AbstractElements";
import CustomerTable from "./CustomerTable";
import FilterTable from "../Common/Component/FilterTable";
import SearchTable from "../Common/Component/SearchTable";
import SelectedFilter from "./SelectedFilter";
import {
  getCustomers,
  getCustomersCount,
  getCustomerTableFilterData,
  getCustomerTableSearchData,
} from "../../Services/Customer.service";
import SharedDataContext from "../../_helper/SharedData";
import { showAlert } from "../../Services/Shared.service";
import { useLocation } from "react-router";
const Customers = () => {
  const location = useLocation();
  const { globalCityField, setShowApiLoader, setPageNumber } =
    useContext(SharedDataContext);
  const [customerData, setCustomerData] = useState([]);
  const [pagination, setPagination] = useState(
    location.state?.pageNumber ? location.state.pageNumber : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [filterData, setFilterData] = useState(location.state?.filterdata?.length > 0 ? location.state?.filterdata : []);
  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [loader, setLoader] = useState(true);
  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");

  let columns = [];
  customerFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };

  const fetchCustomerData = async ({ isSearchFilterPage}) => {
    const serviceCityName = globalCityField.value?.name || "All";
    const cityNameFilter = globalCityField.value?.name || null;
    const obj = {
      serviceCityName,
      page: pagination,
      size: rowsPerPage,
    };
    console.log(filterData, searchData, filterType, "filterType");
    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      await getCustomers(obj)
        .then((result) => {
          setCustomerData(result.data.list);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          showAlert("error", "Something went wrong");
        });

      // let pageObj = {
      //   serviceCityName: serviceCityName,
      // };
      // await getCustomersCount(pageObj).then((result) => {
      //   if (result.data) {
      //     setPaginationTotalRows(result.data);
      //   }
      // });
    } else if (filterData.length > 0 && filterType == "filter") {
      let body = [
        // {
        //   type: "Customer",
        // },
        {
          service_city: cityNameFilter,
        },
      ];
      filterData.forEach((element) => {
        body.push({
          column_name: element.column_name,
          value: element.values[0],
        });
      });
      setLoader(true);
      getCustomerTableFilterData({ ...obj, page: isSearchFilterPage }, body)
        .then((result) => {
          if (result.data) {
            const data = result.data?.filterResponse || [];
            setCustomerData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setCustomerData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      let body = [
        // {
        //   type: "Customer",
        // },
        {
          service_city: cityNameFilter,
        },
        {
          column_names: searchColumns,
          value: searchData,
        },
      ];
      setLoader(true);
      getCustomerTableSearchData(
        { ...obj, page: isSearchFilterPage },
        body
      )
        .then((result) => {
          if (result.data) {
            const data = result.data?.searchResponse || [];
            setCustomerData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setCustomerData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    fetchCustomerData({ isSearchFilterPage: 0 });
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    fetchCustomerData({isSearchFilterPage: 0 });
  }, [searchData]);

  useEffect(async () => {
    fetchCustomerData({isSearchFilterPage: pagination });
  }, [pagination, rowsPerPage, globalCityField.value]);

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };
  return (
    <Fragment>
      <Breadcrumbs
        parent="Customer Management"
        mainTitle="Customer Management"
        span1={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
          />
        }
        span3={
          <SearchTable
            setFilterType={setFilterType}
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                {!loader ? (
                  <CustomerTable
                    customerData={customerData}
                    onChangePage={onChangePage}
                    paginationPerPage={rowsPerPage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    setLoader={setLoader}
                    fetchCustomerData={() =>
                      fetchCustomerData({isSearchFilterPage: pagination })
                    }
                    pagination={pagination}
                    setPageNumber={setPageNumber}
                    pageNumber={
                      location.state?.pageNumber
                        ? location.state.pageNumber + 1
                        : 1
                    }
                    loader={loader}
                    filterData={filterData}
                    searchData={searchData}
                  />
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Customers;
